import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

export const fetchProducts = async (category) => {
  const { data } = await api.get("/products", { params: category ? { category } : {} });
  return data;
};

export const submitContact = (payload) => api.post("/contact", payload).then(r => r.data);
export const submitQuote = (payload) => api.post("/quotes", payload).then(r => r.data);
export const submitB2B = (payload) => api.post("/b2b/sample-request", payload).then(r => r.data);
